import type { FC } from 'react';

import type { TIntangibleDelivery } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import {
  Divider,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

import SummaryQuantity from './summary-quantity.component';

type TDeliverySummary = {
  intangible?: TIntangibleDelivery;
  quantity: number;
  totalDeliveries: number;
};

type TIntangibleDeliveryDetail = {
  intangible: TIntangibleDelivery;
  index: number;
  totalDeliveries: number;
};

const ICON_PROPS = {
  className: 'co-fill-pds-information-500 co-text-pds-information-500',
  size: { width: 24, height: 24 }
};

const IntangibleDeliverySummary: FC<TDeliverySummary> = ({
  intangible,
  totalDeliveries,
  quantity
}) => {
  const customerEmail = intangible?.customerEmail;

  return (
    <div
      className="co-w-full co-h-full co-flex co-items-stretch co-gap-8px lg:co-p-8px co-bg-white lg:co-bg-pds-neutral-100 co-rounded-4px"
      tabIndex={0}
    >
      {totalDeliveries >= 2 && (
        <>
          <SummaryQuantity quantity={quantity} />
          <span className="co-w-1 co-flex-grow co-border-l-1 co-border-[#E6E6E6] "></span>
        </>
      )}
      <div className="co-w-full co-flex co-flex-col co-gap-8px co-overflow-hidden">
        <div className="co-flex co-items-center co-gap-4px">
          <Icon icon="MailIcon" {...ICON_PROPS} />
          <Typography
            color="pds-information-600"
            weight="semibold"
            leading="tight"
          >
            Entrega por correo electrónico
          </Typography>
        </div>

        {totalDeliveries < 2 && <Divider />}

        <p className="co-text-body1 co-text-neutral-grey-500 co-leading-tight">
          Según el tipo de producto, la entrega o el agendamiento se harán por
          medio de este correo:
        </p>
        <p className="co-text-body1 co-text-neutral-grey-500 co-leading-tight co-font-semibold co-overflow-ellipsis co-overflow-hidden">
          {customerEmail}
        </p>
      </div>
    </div>
  );
};

const IntangibleDeliveryDetail: FC<TIntangibleDeliveryDetail> = ({
  intangible,
  index,
  totalDeliveries
}) => {
  const customerEmail = intangible?.customerEmail;

  return (
    <div
      className="co-w-full co-h-full co-flex co-items-center co-gap-8px lg:co-p-8px co-bg-white lg:co-bg-pds-neutral-100 co-rounded-4px"
      key={index}
      tabIndex={0}
    >
      <div className="co-w-full co-flex co-flex-col co-gap-8px">
        <div className="co-flex co-justify-between">
          {totalDeliveries > 1 && (
            <Typography weight="semibold" color="pds-neutral-700" size="body1">
              Entrega {index + 1}
            </Typography>
          )}

          <div className="co-flex co-items-center co-gap-4px">
            <Icon icon="MailIcon" {...ICON_PROPS} />
            <Typography
              color="pds-information-600"
              weight="semibold"
              leading="tight"
            >
              Entrega por correo electrónico
            </Typography>
          </div>
        </div>
        <Divider />
        <p className="co-text-body1 co-text-neutral-grey-500 co-leading-tight">
          Según el tipo de producto, la entrega o el agendamiento se harán por
          medio de este correo:
        </p>
        <p className="co-text-body1 co-text-neutral-grey-500 co-leading-tight co-font-semibold">
          {customerEmail}
        </p>
      </div>
    </div>
  );
};

export { IntangibleDeliveryDetail, IntangibleDeliverySummary };
